export const styles = {
  nameContainer: 'tw-flex tw-items-center tw-gap-3',
  name: 'tw-font-medium tw-text-neutral-900',
  subCount: 'tw-text-sm tw-text-neutral-500',
};
